import { PlaceholderInput } from './PlaceholderInput';
import UIFetchService from '../Service/UIFetchService';
import { ChartBundle, OptionsBundle, DataPreviewModal, Charts, ExprParser, ExprParsingException } from './VisualizationCharts';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import React, { useState } from 'react';
import {
    Row, Col, Button, Input, Layout, Space, Select, Divider, Dropdown, Menu, message, Tabs, Switch, TimePicker,
    InputNumber,
    Tooltip,
    Modal,
    Tag
} from 'antd';
import {
    LeftOutlined, SaveOutlined, DeleteOutlined, UpOutlined, DownOutlined, PauseOutlined, ReloadOutlined, PlusOutlined,
    EditOutlined, CaretDownOutlined, CheckOutlined, EyeInvisibleOutlined, EyeOutlined
} from '@ant-design/icons';
import { isEmpty, isTimeFormat, dateFormat, isNotEmpty, ifEmpty } from '../Service/Utils';
import moment from 'moment';
import 'moment/locale/zh-cn';

const chartKinds = [
    {
        key: 'BAR_CHART',
        title: '柱状图'
    }, {
        key: 'PERCENT_BAR_CHART',
        title: '百分比堆积柱状图'
    }, {
        key: 'STRIPE_CHART',
        title: '条状图'
    }, {
        key: 'PERCENT_STRIPE_CHART',
        title: '百分比堆积条状图'
    }, {
        key: 'PIE_CHART',
        title: '饼状图'
    }, {
        key: 'LINE_CHART',
        title: '折线图'
    }, {
        key: 'TREE_MAP_CHART',
        title: '矩形树图'
    }, {
        key: 'CARD_CHART',
        title: '指标看板'
    }, {
        key: 'FLATTEN_TABLE',
        title: '表格'
    }
]

class VisualizationEditingView extends React.Component {

    static siderDelta = 130
    static emptyChart = {
        key: 'fake',
        dimensions: [],
        indicators: [],
        legends: []
    }

    constructor() {
        super();
        this.state = {
            selected: {
                chart: VisualizationEditingView.emptyChart,
                index: -1,
            },
            rows: [],
            dataSources: [],
            siderHeight: document.body.clientHeight - VisualizationEditingView.siderDelta,
            md: {},
            chartResizeContext: {
                startLine: -1,
                enabled: false,
            },
            fixedCharts: false,
            calculatingEditorModal: {
                visible: false,
            },
            dimensionsOrderModal: {
                visible: false,
                orderKeys: [],
                index: 0,
            },
            dataPreviewModal: {
                visible: false,
                chart: {},
                title: '数据预览'
            },
            dimSearchKey: '',
            idxSearchKey: '',
        }
        //this.allProjection = [];
        this.chartUniqueKey = 0;
        this.exprUniqueKey = 0;
        this.calcUniqueKey = 0;
        this.jobPollingTimers = {};
    }

    render() {
        const menu = <Menu
            onClick={e => this.onAddChart(e.key)}
        >
            {chartKinds.map(c => <Menu.Item
                key={c.key}
            >
                {c.title}
            </Menu.Item>)}
        </Menu>;
        return <div
            style={{ margin: '10px 40px 10px 40px' }}
        >

            <Row style={{ margin: '0 0 10px 0' }}>
                <Col style={{ margin: '0 10px 0 0' }}>
                    <Button
                        icon={<LeftOutlined />}
                        href='/querying_guide/dashboard?tab=Visualization'
                    ></Button>
                </Col>
                <Col flex="300px" style={{ margin: '0 10px 0 0' }}>
                    <Input
                        addonBefore="名称"
                        value={this.state.name}
                        onChange={({ target: { value } }) => this.setState({ name: value })}
                    ></Input>
                </Col>
                <Col flex="400px" style={{ margin: '0 10px 0 0' }}>
                    <Input
                        addonBefore="说明"
                        value={this.state.desc}
                        onChange={({ target: { value } }) => this.setState({ desc: value })}
                    ></Input>
                </Col>
                <Col style={{ margin: '0 10px 0 0', alignSelf: 'center' }}>
                    <Space>
                        <Switch
                            checked={isNotEmpty(this.state.dailyRefreshAt)}
                            onChange={checked => {
                                if (checked) {
                                    this.setState({ dailyRefreshAt: '08:00:00' });
                                } else {
                                    this.setState({ dailyRefreshAt: undefined });
                                }
                            }}
                            checkedChildren='每日更新'
                            unCheckedChildren='Lazy更新'
                        />
                        {isNotEmpty(this.state.dailyRefreshAt) && <>
                            <span>at</span>
                            <TimePicker
                                value={moment(this.state.dailyRefreshAt, 'HH:mm:ss')}
                                onChange={tm => this.setState({ dailyRefreshAt: tm.format('HH:mm:ss') })}
                                defaultValue={moment('08:00:00', 'HH:mm:ss')}
                            //disabled={isEmpty(this.state.dailyRefreshAt)}
                            />
                        </>}
                    </Space>
                </Col>
                <Col style={{ margin: '0 10px 0 0' }}>
                    <Dropdown
                        overlay={menu}
                    >
                        <Button>新增图表</Button>
                    </Dropdown>
                </Col>
                <Col flex="auto"></Col>
                <Col>
                    {/* <Affix offsetTop={72}> */}
                    <Space>
                        <Button
                            type="primary"
                            shape="round"
                            ghost
                            onClick={() => this.setState(({ selected }) => {
                                selected.chart = VisualizationEditingView.emptyChart;
                                selected.index = -1;
                                return { selected };
                            })}
                        >帮助</Button>
                        <Button
                            type="primary"
                            shape="round"
                            ghost
                            onClick={async () => {
                                if (await this.onSaveAll()) {
                                    window.open(`/standalone/visualizations/${this.props.vid}`);
                                }
                            }}
                        >预览</Button>
                        <Button
                            type="primary"
                            shape="round"
                            icon={<SaveOutlined />}
                            onClick={this.onSaveAll.bind(this)}
                        >保存</Button>
                    </Space>
                    {/* </Affix> */}
                </Col>
            </Row>
            <Layout style={{ backgroundColor: '#FFFFFF' }}>

                <Layout.Content
                    style={{
                        height: this.state.siderHeight,
                        overflowY: 'auto'
                    }}
                    id='frameLayout'
                    sider={0}
                >
                    <DragDropContext

                        onDragEnd={({ destination, source }) => {
                            if (isEmpty(destination) || isEmpty(source)) {
                                return;
                            }
                            this.setState(({ rows }) => {
                                const [remove] = rows.splice(source.index, 1);
                                rows.splice(destination.index, 0, remove);
                                return { rows };
                            });
                        }}
                    >
                        <Droppable
                            droppableId='chartsDest'
                            direction='horizontal'>
                            {provided => <>
                                <Row
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                > {this.state.rows.map((chart, index) => <>
                                    <Draggable
                                        isDragDisabled={this.state.fixedCharts}
                                        draggableId={chart.key}
                                        key={chart.key}
                                        index={index}
                                    >
                                        {p1 =>
                                            <Col flex={`${chart.widthInColumns * 25}%`}>
                                                <ChartBundle
                                                    provided={p1}
                                                    chart={chart}
                                                    md={this.state.md}
                                                    clientWidth={document.body.clientWidth - 430}
                                                    isSelected={this.state.selected.index === index}
                                                    readOnly={false}
                                                    placeholders={this.findPlaceholders(chart.templateId)}
                                                    onShowParams={() => this.setState(({ rows }) => {
                                                        if (chart.showParams) {
                                                            chart.showParams = false;
                                                        } else {
                                                            chart.showParams = true;
                                                        }
                                                        return { rows };
                                                    })}
                                                    //onShowDownloadModal={()=>console.log(chart)}
                                                    onShowDownloadModal={() => this.setState(({ dataPreviewModal }) => {
                                                        dataPreviewModal.visible = true;
                                                        dataPreviewModal.mappedProjection = this.mappedProjection;
                                                        dataPreviewModal.chart = chart;
                                                        return { dataPreviewModal };
                                                    })}
                                                    onClick={() => this.setState(({ selected }) => {
                                                        selected.chart = chart;
                                                        selected.index = index;
                                                        return { selected };
                                                    })}
                                                    onDelete={() => this.setState(({ selected, rows }) => {
                                                        if (selected.chart.id > 0) {
                                                            UIFetchService.delete(`/api/v1/querying_guide/visualization/${this.props.vid}/charts/${selected.chart.id}`).then(() => {/*TODO*/ })
                                                        }
                                                        rows.splice(index, 1);
                                                        if (selected.index === index) {
                                                            selected.chart = VisualizationEditingView.emptyChart;
                                                            selected.index = -1;
                                                        }
                                                        return { selected, rows };
                                                    })}
                                                    onParamChanage={(name, value) => this.setState(({ rows }) => {
                                                        chart.params[name] = value;
                                                        return { rows };
                                                    })}
                                                    onRefresh={() => {
                                                        if (chart.updating) {
                                                            clearInterval(this.jobPollingTimers[chart.key]);
                                                            this.setState(({ rows }) => {
                                                                chart.updating = false;
                                                                chart.fatal = false;
                                                                return { rows };
                                                            });
                                                        } else {
                                                            this.onRefresh(chart, true);
                                                        }
                                                    }}
                                                    onResizeStart={(_, chart, e) => {
                                                        this.setState(({ chartResizeContext }) => {
                                                            chartResizeContext.chart = chart;
                                                            chartResizeContext.enabled = true;
                                                            chartResizeContext.baseLine = chart.height
                                                            chartResizeContext.startLine = e.clientY;
                                                            console.log('start', chartResizeContext);
                                                            return { chartResizeContext };
                                                        });
                                                    }}
                                                    onResizePrepare={() => {
                                                        this.setState({ fixedCharts: true });
                                                    }}
                                                    onResizeCancel={() => {
                                                        if (!this.state.chartResizeContext.enabled) {
                                                            this.setState({ fixedCharts: false });
                                                        }
                                                    }}
                                                    onCopy={origin => {
                                                        //console.log(origin);
                                                        const spawn = JSON.parse(JSON.stringify(origin));
                                                        delete spawn.id;
                                                        this.setState(({ rows }) => {
                                                            //rows.push(spawn);
                                                            rows.splice(index, 0, spawn);
                                                            return { rows };
                                                        });
                                                    }}
                                                />
                                                {/* {this.renderChart(p1, chart, index)} */}
                                            </Col>}
                                    </Draggable>
                                </>)}
                                </Row>
                                {provided.placeholder}
                            </>}
                        </Droppable>
                    </DragDropContext>
                </Layout.Content>


                {/* <Affix offsetTop={116}> */}
                <Layout.Sider
                    theme='light'
                    width={400}
                    style={{
                        height: this.state.siderHeight,
                        borderRadius: '4px',
                        border: '1px solid rgb(221, 234, 255)',
                        overflowY: 'auto'
                    }}>

                    {this.hasSelected()
                        ? <DragDropContext
                            onDragStart={() => this.setState({ dragging: true })}
                            onDragEnd={({ destination, source }) => this.onProjectionDragEnd(destination, source)}
                        >
                            <Row>
                                <Col flex="50%" style={{ padding: '10px 6px 10px 6px' }}>
                                    {this.renderPropertiesLeftSider()}
                                </Col>

                                <Col flex="50%" style={{ padding: '10px' }}>
                                    {this.renderPropertiesRightSider()}
                                </Col>
                            </Row>
                        </DragDropContext>
                        : <div style={{ padding: '20px' }}>
                            <Row style={{ margin: '0 0 10px' }}>
                                <Col>
                                    <span style={{ color: '#52c41a', fontSize: 15 }}>从新增或者选择一个图表开始</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span>支持的图表类型有：</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col flex='40px'></Col>
                                <Col flex='auto'>
                                    <span>● 柱状图</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col flex='40px'></Col>
                                <Col>
                                    <span>● 饼状图</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col flex='40px'></Col>
                                <Col flex='auto'>
                                    <span>● 折线图</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col flex='40px'></Col>
                                <Col flex='auto'>
                                    <span>● 指标看板</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col flex='40px'></Col>
                                <Col flex='auto'>
                                    <span>● 表格</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span>只能选择有权限(读取或编辑权限)的天机模版作为数据源</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span>图表右上角按钮的含义：</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span>
                                        <Button size='small' type='link' icon={<UpOutlined />} />
                                        <Button size='small' type='link' icon={<DownOutlined />} />
                                        → 查看/隐藏过滤条件
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span>
                                        <Button size='small' type='link' icon={<ReloadOutlined />} />
                                        <Button size='small' type='link' icon={<PauseOutlined />} />
                                        → 更新图表数据/停止更新图表数据
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span>
                                        <Button size='small' type='link' danger icon={<DeleteOutlined />} />
                                        → 删除图表
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span>图表宽度能按照25%,50%,75%,100%相对于浏览器显示宽度的百分比进行调整。</span>
                                </Col>
                            </Row>
                            <Row style={{ margin: '0 0 5px 0' }}>
                                <Col>
                                    <span>图表高度可以使用鼠标拖动任意调整，最小宽度为300px。</span>
                                </Col>
                            </Row>
                        </div>}
                </Layout.Sider>
                {/* </Affix> */}
            </Layout>
            {this.state.dataPreviewModal.visible && <DataPreviewModal
                {...this.state.dataPreviewModal}

                onClose={() => this.setState(({ dataPreviewModal }) => {
                    dataPreviewModal.visible = false;
                    return { dataPreviewModal };
                })}
            />}
            {this.state.dimensionsOrderModal.visible && <DimensionsOrderModal
                {...this.state.dimensionsOrderModal}
                onOk={(orderKeys, index) => {
                    this.setState(({ selected, dimensionsOrderModal }) => {
                        const dimension = selected.chart.dimensions[index];
                        let dimensionsOrder = selected.chart?.options?.dimensionsOrder;
                        if (!dimensionsOrder) {
                            dimensionsOrder = {};
                        }
                        dimensionsOrder[`${dimension.name}:keys`] = orderKeys;
                        dimensionsOrder[dimension.name] = 'KEYS';
                        dimensionsOrderModal.visible = false;
                        return { selected, dimensionsOrderModal };
                    });
                }}
                onCancel={() => this.setState(({ dimensionsOrderModal }) => {
                    dimensionsOrderModal.visible = false;
                    dimensionsOrderModal.orderKeys = [];
                    dimensionsOrderModal.index = 0;
                    return { dimensionsOrderModal };
                })}
            />}
            {this.state.calculatingEditorModal.visible && <CalculatingEditorModal
                {...this.state.calculatingEditorModal}
                onOk={calculating => this.setState(({ selected, calculatingEditorModal }) => {
                    if (calculatingEditorModal.editing) {
                        selected.chart.calculating[calculatingEditorModal.index] = calculating;
                    } else {
                        if (selected.chart.calculating === undefined) {
                            selected.chart.calculating = [];
                        }
                        for (let i = 0; i < 1000; i++) {
                            const key = `c:${this.calcUniqueKey++}`;
                            if (selected.chart.calculating.find(calc => calc.key === key) === undefined) {
                                calculating.key = key;
                                break;
                            }
                        }
                        selected.chart.calculating.push(calculating);
                    }
                    calculatingEditorModal.visible = false;
                    return { selected, calculatingEditorModal };
                })}
                indicators={this.selectableIndicators()}
                nextKey={() => (this.exprUniqueKey++).toString()}
                renderIndicator={(provided, indicator) => this.renderProjection(provided, indicator, '#52c41a')}
                alreadyExistsName={name => {
                    const calculating = this.state.selected.chart.calculating;
                    const modal = this.state.calculatingEditorModal;
                    //console.log(modal, calculating, name);
                    if (calculating instanceof Array) {
                        if (modal.editing) {
                            return calculating.filter((_, i) => i !== modal.index).find(item => item.name === name) !== undefined;
                        } else {
                            return calculating.find(item => item.name === name) !== undefined;
                        }
                    }
                    return false;
                }}
                onCancel={() => this.setState(({ calculatingEditorModal }) => {
                    calculatingEditorModal.visible = false;
                    return { calculatingEditorModal };
                })}
            />}
        </div>;
    }

    renderPropertiesLeftSider() {
        const droppableStyle = { padding: '1px', border: '1px', borderStyle: 'dotted' };
        return <>
            <Row>
                <Col>
                    <span style={{ fontSize: 12, color: 'gray' }}>类型</span>
                </Col>
            </Row>
            <Row>
                <Select
                    value={this.state.selected.chart.chartKind}
                    onChange={chartKind => this.setState(({ selected, rows }) => {
                        selected.chart.chartKind = chartKind;
                        selected.chart.data = {};
                        return { selected, rows };
                    })}
                    style={{ width: '100%' }}
                    size='small'
                >
                    <Select.Option value="BLOCK">空白</Select.Option>
                    {chartKinds.map(chart => <Select.Option value={chart.key}>{chart.title}</Select.Option>)}
                </Select>
            </Row>
            <Tabs defaultActiveKey='fields' size='small'>
                <Tabs.TabPane tab='字段' key='fields'>

                    <Row>
                        <Col>
                            <span style={{ fontSize: 12, color: 'gray' }}>标题</span>
                        </Col>
                    </Row>
                    <Row>
                        <Col flex='100%'>
                            <Input
                                value={this.state.selected.chart.name}
                                onChange={({ target: { value } }) => this.setState(({ selected }) => {
                                    selected.chart.name = value;
                                    return { selected };
                                })}
                                size='small'
                                style={{ width: '100%' }}
                            ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <span style={{ fontSize: 12, color: 'gray' }}>宽度</span>
                        </Col>
                    </Row>
                    <Row>
                        <Col flex='100%'>
                            <Select
                                value={this.state.selected.chart.widthInColumns}
                                onChange={value => {
                                    this.setState(({ selected, rows }) => {
                                        const chart = selected.chart;
                                        chart.widthInColumns = Number.parseInt(value);
                                        return { rows };
                                    });
                                }}
                                size='small'
                                style={{ width: '100%' }}
                            >
                                <Select value={1}>25%</Select>
                                <Select value={2}>50%</Select>
                                <Select value={3}>75%</Select>
                                <Select value={4}>100%</Select>
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <span style={{ fontSize: 12, color: 'gray' }}>高度</span>
                        </Col>
                    </Row>
                    <Row>
                        <Col flex='100%'>
                            <InputNumber
                                size='small'
                                value={this.state.selected.chart.height}
                                onChange={height => this.setState(({ selected }) => {
                                    selected.chart.height = height;
                                    return { selected };
                                })}
                                min={100}
                                addonAfter='px'
                                style={{ width: '100%' }}
                            ></InputNumber>
                        </Col>
                    </Row>
                    <Divider style={{ margin: '10px 0 10px 0' }} />
                    <Row>
                        <Col>
                            <span style={{ color: 'red' }}>*</span>
                            <span style={{ fontSize: 12, color: 'gray' }}>维度/类别</span>
                        </Col>
                    </Row>
                    <Row style={droppableStyle}>
                        <Col flex='100%'>
                            {this.renderDroppableView(
                                'dimensionsDest',
                                this.state.selected.chart?.dimensions,
                                '#2f54eb',
                                '拖动维度到此处',
                                (index) => {
                                    this.setState(({ selected }) => {
                                        selected.chart.dimensions.splice(index, 1);
                                        return { selected };
                                    });
                                }, this.renderDimensionMenu.bind(this))}
                        </Col>
                    </Row>
                    <Divider style={{ margin: '10px 0 10px 0' }} />
                    <Row>
                        <Col>
                            <span style={{ color: 'red' }}>*</span>
                            <span style={{ fontSize: 12, color: 'gray' }}>指标/数值</span>
                        </Col>
                    </Row>
                    <Row style={droppableStyle}>
                        <Col flex='100%'>
                            {this.renderDroppableView(
                                'indicatorsDest',
                                this.state.selected.chart?.indicators,
                                '#52c41a',
                                '拖动指标/计算字段到此处',
                                (index) => {
                                    this.setState(({ selected }) => {
                                        selected.chart.indicators.splice(index, 1);
                                        return { selected };
                                    });
                                }, this.renderDimensionMenu.bind(this))}
                        </Col>
                    </Row>
                    <Divider style={{ margin: '10px 0 10px 0' }} />
                    <Row>
                        <Col>
                            <span style={{ fontSize: 12, color: 'gray' }}>图例</span>
                        </Col>
                    </Row>
                    <Row style={droppableStyle}>
                        <Col flex='100%'>
                            {this.renderDroppableView(
                                'legendsDest',
                                this.state.selected.chart?.legends,
                                '#2f54eb',
                                '拖动维度到此处',
                                (index) => {
                                    this.setState(({ selected }) => {
                                        selected.chart.legends.splice(index, 1);
                                        return { selected };
                                    });
                                })}
                        </Col>
                    </Row>
                    <Divider style={{ margin: '10px 0 10px 0' }} />
                    <Row>
                        <Col>
                            <span style={{ fontSize: 12, color: 'gray', fontWeight: 'bold' }}>默认参数</span>
                        </Col>
                    </Row>
                    {this.selectedPlaceholders().map((param, index) => <>
                        <Row key={`i-${index}`}>
                            <Col>
                                {isEmpty(param.column) && <span style={{ fontSize: 12, color: 'red' }}>*</span>}
                                <span style={{ fontSize: 12, color: 'gray' }}>{param.name}</span>
                            </Col>
                            <Col flex='auto'></Col>
                            <Col>
                                {/* <Checkbox
                                    size='small'
                                    checked={this.selectedVisible()[param.name]}
                                    onChange={({ target: { checked } }) => {
                                        this.setState(({ selected }) => {
                                            if (selected.chart.visible === undefined) {
                                                selected.chart.visible = {};
                                            }
                                            selected.chart.visible[param.name] = checked;
                                            return { selected };
                                        });
                                    }}
                                ><span style={{ fontSize: 12 }}>隐藏</span></Checkbox> */}
                                <Tooltip title="隐藏/展示过滤条件">
                                    <Button
                                        type='link'
                                        size='small'
                                        icon={this.selectedVisible()[param.name] ? < EyeInvisibleOutlined />
                                            : <EyeOutlined />}
                                        onClick={() => this.setState(({ selected }) => {
                                            if (selected.chart.visible === undefined) {
                                                selected.chart.visible = {};
                                            }
                                            selected.chart.visible[param.name] = !selected.chart.visible[param.name];
                                            console.log(selected.chart.visible);
                                            return { selected };
                                        })}
                                    />
                                </Tooltip>
                            </Col>
                        </Row>
                        <Row key={`j-${index}`}>
                            <Col flex='100%'>
                                <PlaceholderInput
                                    md={this.state.md}
                                    placeholder={param}
                                    rawDate
                                    value={this.state.selected.chart.defaultParams[param.name]}
                                    onChange={value => this.setState(({ selected, rows }) => {
                                        selected.chart.defaultParams[param.name] = value;
                                        delete selected.chart.params[param.name];
                                        return { selected, rows };
                                    })}
                                />
                            </Col>
                        </Row>
                    </>)}
                    <Divider style={{ margin: '10px 0 10px 0' }} />
                    <Row>
                        <Col flex='100%'>
                            <Button
                                style={{ width: '100%' }}
                                type='primary'
                                disabled={this.state.selected.chart.updating}
                                onClick={() => this.onRefresh(this.state.selected.chart, true)}
                            >更新</Button>
                        </Col>
                    </Row>
                </Tabs.TabPane>
                <Tabs.TabPane tab='样式' key='style'>
                    <OptionsBundle
                        chart={this.state.selected.chart}
                        options={this.state.selected.chart.options}
                        onChange={options => this.setState(({ selected }) => {
                            selected.chart.options = options;
                            return { selected };
                        })}
                    />
                </Tabs.TabPane>
            </Tabs>
        </>;
    }

    renderDroppableView(droppableId, items, color, placeholder, onDelete, menu) {
        return <Droppable droppableId={droppableId}>
            {provided => <>
                <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                >
                    {items.length === 0 &&
                        <Draggable
                            draggableId={droppableId + '-fake'}
                            key={droppableId + '-fake'}
                            index={-1}
                        >
                            {p1 => <div
                                ref={p1.innerRef}
                                {...p1.draggableProps}
                                {...p1.dragHandleProps}
                            >
                                <div style={{ width: '100%', textAlign: 'center' }}>
                                    <span style={{ fontSize: 12, color: 'gray' }}>{placeholder}</span>
                                </div>
                            </div>}
                        </Draggable>
                    }
                    {items.map((proj, index) => proj === undefined ? <></> :
                        <Draggable
                            draggableId={droppableId + proj.key}
                            key={droppableId + proj.key}
                            index={index}
                        >
                            {p1 => {
                                let item = undefined;
                                let currentColor = color;
                                if (proj?.key?.startsWith('c:')) {
                                    item = this.state.selected.chart.calculating.find(cal => cal.key === proj.key);
                                    currentColor = '#faad14';
                                } else {
                                    const idx = Number.parseInt(proj.key);
                                    item = this.allProjection[idx];
                                }
                                if (item === undefined) {
                                    console.log(droppableId, proj);
                                }
                                return this.renderProjection(p1, item, currentColor, {
                                    index,
                                    onDelete,
                                    menu: menu ? menu(this.state.selected.chart, proj, index) : undefined
                                });
                            }}
                        </Draggable>
                    )}
                </div>
                {provided.placeholder}
            </>}
        </Droppable>;
    }

    selectedPlaceholders() {
        const templateId = this.state.selected.chart.templateId;
        return this.findPlaceholders(templateId);
    }

    selectedVisible() {
        const visible = this.state.selected.chart.visible;
        return (visible === undefined || visible === null) ? {} : visible;
    }

    findPlaceholders(templateId) {
        if (!(templateId > 0)) {
            return [];
        }
        const ds = this.state.dataSources.find(ds => ds.id === templateId);
        if (isEmpty(ds)) {
            return [];
        }
        return ds.placeholders;
    }

    renderPropertiesRightSider() {
        return <>
            <Row>
                <Col>
                    <span style={{ fontSize: 12, color: 'gray' }}>数据源</span>
                </Col>
            </Row>
            <Row>
                <Col flex="100%">
                    <Select
                        value={this.state.selected.chart.templateId}
                        onChange={templateId => this.setState(({ selected, rows }) => {
                            const chart = selected.chart;
                            chart.templateId = isEmpty(templateId) ? undefined : Number.parseInt(templateId);
                            chart.dimensions = [];
                            chart.indicators = [];
                            //chart.calculating = [];
                            chart.legends = [];
                            chart.data = {};
                            chart.defaultParams = {};
                            chart.params = {};
                            return { selected, rows };
                        })}
                        filterOption={(input, option) => option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        size='small'
                        placeholder="请选择数据源"
                        style={{ width: '170px' }}
                        showSearch
                        allowClear
                    >
                        {this.state.dataSources.map(ds => <Select.Option
                            key={ds.id}
                            value={ds.id}
                            title={ds.name}
                        >
                            {ds.name}
                        </Select.Option>)}
                    </Select>
                </Col>
            </Row>
            <Divider style={{ margin: '10px 0 10px 0' }} />
            <Row>
                <Col>
                    <span style={{ fontSize: 12, color: 'gray' }}>维度</span>
                </Col>
            </Row>
            <Row style={{ margin: '0 0 2px 0' }}>
                <Col>
                    <Input.Search
                        size='small'
                        value={this.state.dimSearchKey}
                        allowClear
                        onChange={({ target: { value } }) => this.setState({ dimSearchKey: value })}
                    />
                </Col>
            </Row>
            <Row>
                <Col flex='100%'>
                    <Droppable
                        droppableId='dimensionsSrc'
                    >
                        {provided => <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                        >
                            {this.selectableDimensions().filter(this.dimsFilter).map((proj, index) =>
                                <Draggable
                                    draggableId={proj.key}
                                    index={index}
                                    key={proj.key}
                                >
                                    {p1 => this.renderProjection(p1, proj, '#2f54eb', {
                                        onAdd: proj => this.setState(({ selected }) => {
                                            selected.chart.dimensions.push({ ...proj });
                                            return { selected };
                                        }),
                                        isAddable: proj => this.state.selected.chart.dimensions.find(d => d.key === proj.key) === undefined
                                    })}
                                </Draggable>
                            )}
                            {provided.placeholder}
                        </div>}
                    </Droppable>
                </Col>
            </Row>
            <Divider style={{ margin: '10px 0 10px 0' }} />
            <Row>
                <Col>
                    <span style={{ fontSize: 12, color: 'gray' }}>指标</span>
                </Col>
            </Row>
            <Row style={{ margin: '0 0 2px 0' }}>
                <Col>
                    <Input.Search
                        size='small'
                        value={this.state.idxSearchKey}
                        allowClear
                        onChange={({ target: { value } }) => this.setState({ idxSearchKey: value })}
                    />
                </Col>
            </Row>
            <Row>
                <Col flex='100%'>
                    <Droppable
                        droppableId='indicatorsSrc'
                    >
                        {provided => <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                        >
                            {this.selectableIndicators().filter(this.idxsFilter).map((proj, index) =>
                                <Draggable
                                    draggableId={proj.key}
                                    index={index}
                                    key={proj.key}
                                >
                                    {p1 => this.renderProjection(p1, proj, '#52c41a', {
                                        onAdd: proj => this.setState(({ selected }) => {
                                            selected.chart.indicators.push({ ...proj });
                                            return { selected };
                                        }),
                                        isAddable: proj => this.state.selected.chart.indicators.find(d => d.key === proj.key) === undefined
                                    })}
                                </Draggable>
                            )}
                            {provided.placeholder}
                        </div>}
                    </Droppable>
                </Col>
            </Row>
            <Divider style={{ margin: '10px 0 10px 0' }} />
            <Row>
                <Col>
                    <span style={{ fontSize: 12, color: 'gray' }}>计算字段</span>
                </Col>
                <Col flex='auto'>
                </Col>
                <Col>
                    <Tooltip
                        title='增加一个计算字段'
                    >
                        <Button
                            type='link'
                            icon={<PlusOutlined />}
                            size='small'
                            onClick={() => this.setState(({ selected, calculatingEditorModal }) => {
                                calculatingEditorModal.visible = true;
                                calculatingEditorModal.templateId = selected.chart.templateId;
                                calculatingEditorModal.editing = false;
                                return { calculatingEditorModal };
                            })}
                        ></Button>
                    </Tooltip>
                </Col>
            </Row>
            <Row>
                <Col flex='100%'>
                    <Droppable
                        droppableId='calculatingSrc'
                    >
                        {provided => <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                        >
                            {this.state.selected.chart?.calculating?.map((proj, index) =>
                                <Draggable
                                    draggableId={proj.key}
                                    index={index}
                                    key={proj.key}
                                >
                                    {p1 => this.renderProjection(
                                        p1,
                                        proj,
                                        '#faad14', {
                                        index,
                                        onDelete: indexForDeleting => this.setState(({ selected }) => {
                                            //console.log(indexForDeleting, selected.chart.calculating);
                                            const calc = selected.chart.calculating[indexForDeleting];
                                            selected.chart.calculating = selected.chart.calculating.filter((_, i) => i !== indexForDeleting);
                                            selected.chart.indicators = selected.chart.indicators.filter(i => i.key !== calc.key);
                                            return { selected };
                                        }),
                                        onEdit: indexForEditing => this.setState(({ selected: { chart }, calculatingEditorModal }) => {
                                            calculatingEditorModal.visible = true;
                                            calculatingEditorModal.editing = true;
                                            calculatingEditorModal.index = indexForEditing;
                                            calculatingEditorModal.data = chart.calculating[index];
                                            return { calculatingEditorModal };
                                        }),
                                        onAdd: proj => this.setState(({ selected }) => {
                                            selected.chart.indicators.push({ ...proj });
                                            return { selected };
                                        }),
                                        isAddable: proj => this.state.selected.chart.indicators.find(d => d.key === proj.key) === undefined
                                    })}
                                </Draggable>
                            )}
                            {provided.placeholder}
                        </div>}
                    </Droppable>
                </Col>
            </Row>
        </>;
    }

    dimsFilter = proj => {
        if (isEmpty(this.state.dimSearchKey)) {
            return true;
        }
        return ifEmpty(proj.desc, '').toLowerCase().indexOf(this.state.dimSearchKey.toLowerCase()) >= 0
    };

    idxsFilter = proj => {
        if (isEmpty(this.state.idxSearchKey)) {
            return true;
        }
        return ifEmpty(proj.desc, '').toLowerCase().indexOf(this.state.idxSearchKey.toLowerCase()) >= 0
    };

    async componentDidMount() {
        this.allProjection = [];
        this.mappedProjection = {};
        const dataSources = await UIFetchService.get('/api/v1/querying_guide/templates/for_datasource');
        let key = 0;
        for (let ds of dataSources) {
            this.mappedProjection[ds.id] = {}
            for (let item of ds.dimensions) {
                item.key = (key++).toString();
                this.allProjection.push(item);
                this.mappedProjection[ds.id][item.name] = item;
            }
            for (let item of ds.indicators) {
                item.key = (key++).toString();
                this.allProjection.push(item);
                this.mappedProjection[ds.id][item.name] = item;
            }
        }
        this.setState({ dataSources });

        UIFetchService.get('/api/v1/metadata/provinces/tree').then(provinces =>
            this.setState(({ md }) => {
                md.provinces = provinces;
                return { md };
            }));
        UIFetchService.get('/api/v1/metadata/word_books/tree').then(bookCategories =>
            this.setState(({ md }) => {
                md.bookCategories = bookCategories;
                return { md };
            }));
        UIFetchService.get('/api/v1/metadata/ad/to_groups_to_objects').then(toGroupsToObjects =>
            this.setState(({ md }) => {
                md.toGroupsToObjects = toGroupsToObjects;
                return { md };
            }));
        UIFetchService.get('/api/v1/metadata/ad/ad_resource_slots').then(adSlots =>
            this.setState(({ md }) => {
                md.adSlots = adSlots;
                return { md };
            }));

        const processProjections = (items, templateId) => {
            for (let item of items) {
                const ds = this.mappedProjection[templateId];
                if (ds === undefined) {
                    continue;
                }
                if (item.name.startsWith('c:')) {
                    item.key = item.name;
                } else {
                    const pj = ds[item.name];
                    if (pj === undefined) {
                        continue;
                    }
                    item.key = pj.key;
                }
            }
        }
        const rs = await UIFetchService.get(`/api/v1/querying_guide/visualization/${this.props.vid}`);
        for (let chart of rs.rows) {
            chart.key = (this.chartUniqueKey++).toString();
            chart.data = {};
            chart.params = {};
            processProjections(chart.dimensions, chart.templateId);
            processProjections(chart.indicators, chart.templateId);
            processProjections(chart.legends, chart.templateId);
            if (chart.templateId > 0 && chart.chartKind !== 'BLOCK') {
                this.onRefresh(chart);
            }
        }
        this.setState(rs);



        window.onresize = () => {
            this.setState({ siderHeight: document.body.clientHeight - VisualizationEditingView.siderDelta });
        };
        window.onmousemove = e => {
            if (this.state.chartResizeContext.enabled) {

                this.setState(({ chartResizeContext, rows }) => {
                    const deltaH = e.clientY - chartResizeContext.startLine;
                    chartResizeContext.chart.height = chartResizeContext.baseLine + deltaH;
                    if (chartResizeContext.chart.height < 100) {
                        chartResizeContext.chart.height = 100;
                    }
                    return { chartResizeContext, rows };
                });
            }
        }
        window.onmouseup = e => {
            if (this.state.chartResizeContext.enabled) {
                this.setState(({ chartResizeContext }) => {
                    chartResizeContext.startLine = -1;
                    chartResizeContext.chart = undefined;
                    chartResizeContext.enabled = false;
                    console.log('stop', chartResizeContext);
                    return { chartResizeContext, fixedCharts: false };
                });
            }
        }
    }

    componentWillUnmount() {
        delete window.onresize;
    }

    renderDimensionMenu(chart, proj, index) {
        let dimensionsOrder = chart.options?.dimensionsOrder
        if (!dimensionsOrder) {
            dimensionsOrder = {};
            chart.options.dimensionsOrder = dimensionsOrder;
        }
        const order = dimensionsOrder[proj.name];
        let orderBy = undefined;
        if (isEmpty(order) || order === 'ASC') {
            orderBy = 'ASC';
        } else {
            orderBy = order;
        }
        const orderPrefix = 'dimOrder';
        const renderMenuItem = (key, orderBy, title) =>
            <Menu.Item key={`${orderPrefix}${key}`}>
                <span style={{ fontSize: 12, margin: key !== orderBy && '0 0 0 20px' }}>
                    {key === orderBy && < CheckOutlined />}{title}
                </span>
            </Menu.Item>;

        return <Menu
            theme='dark'
            style={{ fontSize: 12 }}
            onClick={({ key }) => {
                switch (key) {
                    case 'dimOrderASC':
                        dimensionsOrder[proj.name] = 'ASC';
                        break;
                    case 'dimOrderDESC':
                        dimensionsOrder[proj.name] = 'DESC';
                        break;
                    case 'dimOrderKEYS':
                        this.setState(({ dimensionsOrderModal }) => {
                            dimensionsOrderModal.visible = true;
                            const key = `${proj.name}:keys`;
                            dimensionsOrderModal.orderKeys = dimensionsOrder[key] ? dimensionsOrder[key] : [];
                            dimensionsOrderModal.index = index;
                            return { dimensionsOrderModal };
                        });
                        break;
                    default:
                        break;
                }
                this.setState(({ selected }) => {
                    return { selected };
                });
            }}
        >
            {[
                renderMenuItem('ASC', orderBy, '升序'),
                renderMenuItem('DESC', orderBy, '降序'),
                renderMenuItem('KEYS', orderBy, '自定义排序'),
            ]}
        </Menu>;
    }

    renderProjection(provided, proj, color, options) {
        const { index, menu, onDelete, onEdit, onAdd, isAddable } = options ? options : {};
        if (proj === undefined || proj === null) {
            return <div
                key={index}
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
            >
                <Row
                    style={{
                        backgroundColor: 'red',
                        padding: '2px 12px 2px 12px',
                        borderRadius: '4px',
                        border: '1px solid rgb(221, 234, 255)',
                        alignSelf: 'center'
                    }}
                >
                    <Col>
                        <span style={{ fontSize: 12, color: '#FFFFFF' }}>{'<字段被删除>'}</span>
                    </Col>
                    <Col flex='auto'></Col>
                    {onDelete && <Col>
                        <Button
                            icon={<DeleteOutlined />}
                            size='small'
                            type='link'
                            style={{ color: '#ffffff' }}
                            onClick={() => onDelete(index)}
                        ></Button>
                    </Col>}
                </Row>
            </div>;
        }
        return <div
            key={proj.key}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
        >
            <Row
                style={{
                    backgroundColor: onAdd ? '#FFFFFF' : color,
                    padding: '2px 12px 2px 12px',
                    borderRadius: '4px',
                    border: onAdd ? `1px solid ${color}` : '1px solid rgb(221, 234, 255)',
                    margin: onAdd && '2px 0 0 0',
                    alignSelf: 'center'
                }}
            >
                <Col>
                    <span style={{ fontSize: 12, color: onAdd ? color : '#FFFFFF' }}>{proj.desc}</span>
                </Col>
                {(onDelete || onEdit || onAdd || menu) && <Col flex='auto'></Col>}
                {menu && <Col>
                    <Dropdown
                        overlay={menu}
                    >
                        <Button
                            icon={<CaretDownOutlined />}
                            size='small'
                            type='link'
                            style={{ color: '#ffffff' }}
                        />
                    </Dropdown>
                </Col>}
                {(onAdd && isAddable(proj)) && <Col>
                    <Button
                        icon={<PlusOutlined />}
                        size='small'
                        type='link'
                        style={{ color, height: 12 }}
                        onClick={() => onAdd(proj)}
                    ></Button>
                </Col>}
                {onEdit && <Col>
                    <Button
                        icon={<EditOutlined />}
                        size='small'
                        type='link'
                        style={{ color: onAdd ? color : '#ffffff', height: 12 }}
                        onClick={() => onEdit(index)}
                    ></Button>
                </Col>}
                {onDelete && <Col>
                    <Button
                        icon={<DeleteOutlined />}
                        size='small'
                        type='link'
                        style={{ color: onAdd ? color : '#ffffff', height: 12 }}
                        onClick={() => onDelete(index)}
                    ></Button>
                </Col>}
            </Row>
        </div>;
    }

    onProjectionDragEnd(destination, source) {
        //console.log(destination, source);
        this.setState({ dragging: false });
        if (isEmpty(destination) || isEmpty(source)) {
            return;
        }
        if (source.index < 0) {
            return;
        }
        if (destination.droppableId === 'dimensionsDest') {
            if (source.droppableId === 'dimensionsSrc') {
                const dim = this.selectableDimensions().filter(this.dimsFilter)[source.index];
                if (this.state.selected.chart.dimensions.find(d => d.key === dim.key)) {
                    message.error(`不能添加重复的维度：${dim.desc}`);
                    return;
                }

                this.setState(({ selected, rows }) => {
                    selected.chart.dimensions.splice(destination.index, 0, {
                        key: dim.key,
                        name: dim.name
                    });
                    return { selected, rows };
                });
            } else if (source.droppableId === 'dimensionsDest') {
                this.setState(({ selected, rows }) => {
                    const [remove] = selected.chart.dimensions.splice(source.index, 1);
                    selected.chart.dimensions.splice(destination.index, 0, remove);
                    return { selected, rows };
                });
            }
        } else if (destination.droppableId === 'indicatorsDest') {
            if (source.droppableId === 'indicatorsSrc') {
                const dim = this.selectableIndicators().filter(this.idxsFilter)[source.index];
                if (this.state.selected.chart.indicators.find(d => d.key === dim.key)) {
                    message.error(`不能添加重复的指标：${dim.desc}`);
                    return;
                }
                this.setState(({ selected }) => {
                    selected.chart.indicators.splice(destination.index, 0, {
                        key: dim.key,
                        name: dim.name
                    });
                    return { selected };
                });
            } else if (source.droppableId === 'calculatingSrc') {
                const dim = this.state.selected.chart.calculating[source.index];
                if (this.state.selected.chart.indicators.find(d => d.key === dim.key)) {
                    message.error(`不能添加重复的计算字段：${dim.desc}`);
                    return;
                }
                this.setState(({ selected }) => {
                    selected.chart.indicators.splice(destination.index, 0, {
                        key: dim.key,
                        name: dim.key
                    });
                    return { selected };
                });
            } else if (source.droppableId === 'indicatorsDest') {
                this.setState(({ selected, rows }) => {
                    const [remove] = selected.chart.indicators.splice(source.index, 1);
                    selected.chart.indicators.splice(destination.index, 0, remove);
                    return { selected, rows };
                });
            }
        } else if (destination.droppableId === 'legendsDest') {
            if (source.droppableId === 'dimensionsSrc') {
                const dim = this.selectableDimensions()[source.index];
                if (this.state.selected.chart.legends.find(d => d.key === dim.key)) {
                    message.error(`不能添加重复的维度：${dim.desc}`);
                    return;
                }

                this.setState(({ selected, rows }) => {
                    selected.chart.legends.splice(destination.index, 0, {
                        key: dim.key,
                        name: dim.name
                    });
                    return { selected, rows };
                });
            } else if (source.droppableId === 'legendsDest') {
                this.setState(({ selected, rows }) => {
                    const [remove] = selected.chart.legends.splice(source.index, 1);
                    selected.chart.legends.splice(destination.index, 0, remove);
                    return { selected, rows };
                });
            }
        }
    }

    selectableDimensions() {
        const ds = this.state.dataSources.find(ds => ds.id === this.state.selected.chart.templateId);
        if (ds) {
            // const selected = new Set(this.state.selected.chart.dimensions.map(d => d.key));
            // return ds.dimensions.filter(d => !selected.has(d.key));
            return ds.dimensions;
        } else {
            return [];
        }
    }

    selectableIndicators() {
        const ds = this.state.dataSources.find(ds => ds.id === this.state.selected.chart.templateId);
        if (ds) {
            // const selected = new Set(this.state.selected.chart.indicators.map(d => d.key));
            // return ds.indicators.filter(d => !selected.has(d.key));
            return ds.indicators;
        } else {
            return [];
        }
    }

    async onRefresh(chart, force) {
        if (chart.id === undefined) {
            await this.onSaveAll();
        }
        if (!(chart.templateId > 0)) {
            return;
        }
        if (chart.chartKind !== 'CARD_CHART' && chart.dimensions.length + chart.legends.length === 0) {
            message.error('没有选择任何维度！');
            return;
        }
        if (chart.indicators.length === 0) {
            message.error('没有选择任何指标！');
            return;
        }
        const re = /^\${dt-(\d+)}$/;
        const placeholders = this.findPlaceholders(chart.templateId);
        for (let param of placeholders) {
            if (isEmpty(chart.params[param.name])) {
                if (isEmpty(param.column) && isEmpty(chart.defaultParams[param.name])) {
                    message.error(`参数: ${param.name} 不能为空`);
                    return;
                }

                const defVal = chart.defaultParams[param.name];
                if (isEmpty(defVal)) {
                    continue;
                }
                if (isTimeFormat(param.format)) {
                    if (defVal instanceof Array) {
                        const vals = ['', ''];
                        let m = ifEmpty(defVal[0], '').trim().match(re);
                        if (m != null) {
                            vals[0] = moment().subtract(m[1], 'days').format(dateFormat);
                        } else {
                            vals[0] = defVal[0];
                        }
                        m = ifEmpty(defVal[1], '').trim().match(re);
                        if (m != null) {
                            vals[1] = moment().subtract(m[1], 'days').format(dateFormat);
                        } else {
                            vals[1] = defVal[1];
                        }
                        chart.params[param.name] = vals;
                    } else {
                        const m = defVal.trim().match(re);
                        if (m !== null) {
                            chart.params[param.name] = moment().subtract(m[1], 'days').format(dateFormat);
                        } else {
                            chart.params[param.name] = defVal;
                        }
                    }
                } else {
                    chart.params[param.name] = defVal;
                }
            }
        }

        this.setState(({ rows }) => {
            chart.updating = true;
            chart.fakePercent = 0.0;
            return { rows };
        });

        const params = {
            placeholders: {},
            dimensions: [],/*chart.dimensions.map(d => d.name),*/
            indicators: chart.indicators.filter(d => !d.name.startsWith('c:')).map(d => d.name),
        };
        chart.indicators
            .filter(d => d.name.startsWith('c:'))
            .map(d => chart.calculating.find(calc => calc.key === d.key))
            .filter(calc => calc !== undefined)
            .forEach(calc => {
                for (const node of calc.expression) {
                    if (isNotEmpty(node.name)) {
                        params.indicators.push(node.name);
                    }
                }
            });
        if (Charts.isTable(chart) || Charts.isTreeMap(chart)) {
            for (const f of chart.dimensions) {
                params.dimensions.push(f.name);
            }
            for (const f of chart.legends) {
                params.dimensions.push(f.name);
            }
        } else {
            if (chart.dimensions.length > 0) {
                params.dimensions.push(chart.dimensions[0].name);
            }
            if (chart.legends.length > 0) {
                params.dimensions.push(chart.legends[0].name);
            }
        }
        for (let key of Object.keys(chart.params)) {
            const val = chart.params[key];
            if (val instanceof Array) {
                params.placeholders[key] = val.join(',');
            } else {
                params.placeholders[key] = val;
            }
        }
        const query = force ? '?force=true' : '';
        const url = `/api/v1/querying_guide/visualization/${this.props.vid}/charts/${chart.id}/post_running_by_names${query}`;
        const rs = await UIFetchService.post(url, params);
        if (!rs) {
            this.setState(({ rows }) => {
                chart.updating = false;
                chart.fatal = true;
                return { rows };
            });
            return;
        }
        if (rs.cached) {
            const data = await UIFetchService.get(`/api/v1/querying_guide/jobs/${rs.jobId}/all_result`);
            this.setState(({ rows }) => {
                chart.updating = false;
                chart.fatal = false;
                Charts.processRows(chart, data, name => {
                    //console.log(chart, name, this.mappedProjection);
                    if (name.startsWith('c:')) {
                        return chart.calculating.find(calc => calc.key === name)?.name;
                    } else {
                        return this.mappedProjection[chart.templateId][name]?.desc;
                    }
                });
                return { rows };
            });
        } else {
            this.beginPolling(chart, rs.jobId, rs.estimatedCostSeconds);
        }
    }

    beginPolling(chart, jobId, estimatedCostSeconds) {
        const fakeIncrement = 100 / estimatedCostSeconds;
        this.jobPollingTimers[chart.key] = setInterval(async () => {
            const status = await UIFetchService.get(`/api/v1/querying_guide/jobs/${jobId}/status`);
            switch (status.status) {
                case 'INIT':
                case 'RUNNING':
                    this.setState(({ rows }) => {
                        if (chart.fakePercent < 99) {
                            chart.fakePercent += fakeIncrement;
                        }
                        if (chart.fakePercent > 99) {
                            chart.fakePercent = 99;
                        }
                        return { rows };
                    })
                    break;
                case 'FAIL':
                    message.error(`执行失败：${status.logs}`);
                    clearInterval(this.jobPollingTimers[chart.key]);
                    this.setState(({ rows }) => {
                        chart.updating = false;
                        chart.fatal = status.logs;
                        return { rows };
                    });
                    break;
                case 'OK':
                    clearInterval(this.jobPollingTimers[chart.key]);
                    const data = await UIFetchService.get(`/api/v1/querying_guide/jobs/${jobId}/all_result`);
                    this.setState(({ rows }) => {
                        chart.updating = false;
                        chart.fatal = false;
                        Charts.processRows(chart, data, name => {
                            if (name.startsWith('c:')) {
                                const item = chart.calculating.find(cal => cal.key === name);
                                return ifEmpty(item.desc, name);
                            } else {
                                return ifEmpty(this.mappedProjection[chart.templateId][name].desc, name);
                            }
                        });
                        return { rows };
                    });
                    break;
                default:
                    break;
            }
        }, 2000);
    }

    onAddChart(kind) {
        this.setState(({ selected, rows }) => {
            const chart = {
                widthInColumns: 1,
                chartKind: isEmpty(kind) ? 'BLOCK' : kind,
                dimensions: [],
                indicators: [],
                legends: [],
                calculating: [],
                height: 300,
                showParams: true,
                params: {},
                defaultParams: {},
                data: {},
                options: {},
                key: (this.chartUniqueKey++).toString()
            };
            rows.push(chart);
            selected.chart = chart;
            selected.index = rows.length - 1;
            return { selected, rows };
        });
    }

    async onSaveAll() {
        if (isEmpty(this.state.name)) {
            message.error('看板名称为空');
            return;
        }
        let hasError = false;
        for (let i = 0; i < this.state.rows.length; i++) {
            const chart = this.state.rows[i];
            if (!(chart.templateId > 0)) {
                continue;
            }
            const ds = this.state.dataSources.find(ds => ds.id === chart.templateId);
            if (!ds) {
                continue;
            }
            for (const ph of ds.placeholders) {
                if (isEmpty(ph.column) && isEmpty(chart.defaultParams[ph.name])) {
                    const { selected } = this.state;
                    selected.chart = chart;
                    selected.index = i;
                    this.setState({ selected });
                    hasError = true;
                    break;
                }
            }
        };
        if (hasError) {
            message.error('必须配置所有的必选默认参数。');
            return;
        }

        const params = {
            id: this.props.vid,
            name: this.state.name,
            desc: this.state.desc,
            dailyRefreshAt: this.state.dailyRefreshAt,
            rows: this.state.rows
        };

        const rs = await UIFetchService.put(`/api/v1/querying_guide/visualization/${this.props.vid}`, params);
        if (!rs) {

        } else {
            this.setState(({ rows }) => {
                for (let i = 0; i < rs.length; i++) {
                    rows[i].id = rs[i];
                }
                return { rows };
            })
            message.success('保存成功');
        }
        return true;
    }

    addDefaultRow() {
        const rows = this.state.rows;
        const row = {
            height: 300,
            charts: []
        }
        rows.push(row);
        this.setState({ rows });
        return row;
    }

    getLatestRow() {
        const rows = this.state.rows;
        if (this.state.rows.length === 0) {
            return undefined;
        }
        return rows[rows.length - 1];
    }

    getWidthInColumns(row) {
        let width = 0;
        for (let col of row.charts) {
            width += col.widthInColumns;
        }
        return width;
    }

    hasSelected() {
        //console.log(this.state.selected);
        if (this.state.rows.length === 0) {
            return false;
        }
        return this.state.selected.chart.key !== 'fake' && this.state.selected.index >= 0;
    }
}

const calculatingOperators = [
    {
        op: '+',
        title: '加',
        color: '#eb2f96'
    }, {
        op: '-',
        title: '减',
        color: '#eb2f96'
    }, {
        op: '*',
        title: '乘',
        color: '#eb2f96'
    }, {
        op: '/',
        title: '除',
        color: '#eb2f96'
    }, {
        op: '()',
        title: '括号',
        color: '#13c2c2'
    }
];

function CalculatingEditorModal(props) {
    const [data, setData] = useState(props.editing ? { ...props.data } : { expression: [] });
    const [incomingConstVal, setIncomingConstVal] = useState();
    const [incomingConstValError, setIncomingConstValError] = useState();
    const [exprErrorPos, setExprErrorPos] = useState();
    const [nameError, setNameError] = useState();
    //const [, setDragging] = useState(false);

    const nextKey = () => {
        while (true) {
            let key = `e:${props.nextKey()}`;
            if (!data.expression.find(expr => expr.key === key)) {
                return key;
            }
        }
    }

    const operators = <>
        <Row justify='center'>
            <Col>
                <span style={{ fontSize: 12, color: 'gray' }}>操作符</span>
            </Col>
        </Row>
        <Row justify='center'>
            <Col flex='160px'>
                <Droppable
                    droppableId='operatorsSrc'
                    direction='vertical'
                >
                    {provided => <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                    >
                        {calculatingOperators.map((op, index) =>
                            <Draggable
                                draggableId={op.op}
                                index={index}
                                key={op.op}
                            >
                                {p1 => <div
                                    key={op.key}
                                    ref={p1.innerRef}
                                    {...p1.draggableProps}
                                    {...p1.dragHandleProps}
                                >
                                    <Row
                                        style={{
                                            backgroundColor: op.color,
                                            padding: '2px 12px 2px 12px',
                                            borderRadius: '4px',
                                            border: '1px solid rgb(221, 234, 255)',
                                            alignSelf: 'center'
                                        }}
                                    >
                                        <Col>
                                            <span style={{ fontSize: 12, color: '#FFFFFF' }}>{op.title}</span>
                                        </Col>
                                    </Row>
                                </div>}
                            </Draggable>
                        )}
                        {provided.placeholder}
                    </div>}
                </Droppable>
            </Col>
        </Row>
    </>;

    const constVal = <>
        <Row justify='center'>
            <Col>
                <span style={{ fontSize: 12, color: 'gray' }}>常数</span>
            </Col>
        </Row>
        <Row justify='center'>
            <Col flex='135px'>
                <Input
                    value={incomingConstVal}
                    size='small'
                    onChange={({ target: { value } }) => {
                        setIncomingConstVal(value);
                    }}
                />
            </Col>
            <Col>
                <Button
                    icon={<PlusOutlined />}
                    type='link'
                    size='small'
                    onClick={() => {
                        const maybeNumber = Number.parseFloat(incomingConstVal);
                        if (typeof maybeNumber !== 'number' || Number.isNaN(maybeNumber)) {
                            setIncomingConstValError('不是有效的常量');
                            return;
                        }
                        setIncomingConstValError(undefined);
                        setIncomingConstVal(undefined);
                        data.expression = [...data.expression, { key: nextKey(), value: maybeNumber }];
                        setData(data);
                    }}
                />
            </Col>
        </Row>
        {isNotEmpty(incomingConstValError) && <Row justify='center'>
            <Col>
                <span style={{ color: 'red' }}>{incomingConstValError}</span>
            </Col>
        </Row>}
    </>;


    const indicators = <>
        <Row justify='center'>
            <Col>
                <span style={{ fontSize: 12, color: 'gray' }}>指标</span>
            </Col>
        </Row>
        <Row justify='center'>
            <Col flex='160px' style={{ height: 220, overflowY: 'auto' }}>
                <Droppable
                    droppableId='indicatorsSrc'
                    direction='vertical'
                >
                    {provided => <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                    >
                        {props.indicators.map((proj, index) =>
                            <Draggable
                                draggableId={proj.key}
                                index={index}
                                key={proj.key}
                            >
                                {p1 => props.renderIndicator(p1, proj)}
                            </Draggable>
                        )}
                        {provided.placeholder}
                    </div>}
                </Droppable>
            </Col>
        </Row>
    </>;

    const reanderExpression = (p1, expr) => {
        let color = '';
        let title = '';
        if (expr.op === '(' || expr.op === ')') {
            color = '#13c2c2';
            title = expr.op;
        } else if (isNotEmpty(expr.op)) {
            color = '#eb2f96';
            title = expr.op;
        } else if (isNotEmpty(expr.name)) {
            color = '#52c41a';
            title = expr.desc;
        } else if (expr.value !== undefined) {
            color = '#fa8c16';
            title = expr.value.toString();
        }

        return <span

            style={{
                backgroundColor: color,
                padding: '2px 12px 2px 12px',
                borderRadius: '4px',
                border: '1px solid rgb(221, 234, 255)',
                alignSelf: 'center',
                color: '#FFFFFF',
            }}
        >
            {title}
        </span>
    };

    const expression = <Droppable
        droppableId='expressionDest'
        direction='horizontal'
    >
        {provided => <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            style={{ display: 'flex' }}
        >
            {data.expression.length === 0 &&
                <Draggable
                    draggableId={'placeholder'}
                    key={'placeholder'}
                    index={-1}

                >
                    {p1 => <span
                        ref={p1.innerRef}
                        {...p1.draggableProps}
                        {...p1.dragHandleProps}
                    >
                        <div style={{ width: '100%', textAlign: 'center' }}>
                            <span style={{ fontSize: 12, color: 'gray' }}>拖动指标或操作符到此处</span>
                        </div>
                    </span>}
                </Draggable>
            }
            {data.expression.map((expr, index) =>
                <Draggable
                    draggableId={expr.key}
                    index={index}
                    key={expr.key}
                >
                    {p1 => <div
                        key={expr.key}
                        ref={p1.innerRef}
                        {...p1.draggableProps}
                        {...p1.dragHandleProps}
                        style={{
                            userSelect: 'none',
                            border: (exprErrorPos === index && '1px solid red'),
                            ...p1.draggableProps.style,
                        }}
                    >
                        {reanderExpression(p1, expr)}
                    </div>}
                </Draggable>
            )}
            {provided.placeholder}
        </div>}
    </Droppable>;

    return <Modal
        {...props}
        onOk={() => {
            if (!data.expression instanceof Array || data.expression.length === 0) {
                message.error('没有设置表达式');
                return;
            }
            if (isEmpty(data.name)) {
                message.error('没有设置计算字段名');
                setNameError('没有设置计算字段名');
                return;
            }
            if (props.alreadyExistsName(data)) {
                message.error('计算字段名重复');
                setNameError('计算字段名重复');
                return;
            }
            try {
                const ast = new ExprParser(data.expression).parse();
                data.ast = ast;
                data.desc = data.name;
                setData(data);
                //console.log(ast);
                props.onOk(data);
            } catch (e) {
                if (e instanceof ExprParsingException) {
                    message.error(`表达式错误${e.message} at ${e.index}`);
                    setExprErrorPos(e.index);
                }

            }
        }}
        title={props.editing ? '编辑计算字段' : '新建计算字段'}
        maskClosable={false}
    >
        <Row>
            <Col style={{ alignSelf: 'center' }}>
                <span>字段名：</span>
            </Col>
            <Col>
                <Input
                    style={{ width: 300 }}
                    value={data.name}
                    onChange={({ target: { value } }) => {
                        data.name = value;
                        setData({ ...data });
                        // if (props.alreadyExistsName(value)) {
                        //     setNameError('计算字段名重复');
                        // } else {
                        //     setNameError();
                        // }
                    }}
                />
            </Col>
            {isNotEmpty(nameError) && <Col>
                <span style={{ color: 'red' }}>{nameError}</span>
            </Col>}
        </Row>
        <DragDropContext
            // onDragStart={() => setDragging(true)}
            onDragEnd={({ destination, source }) => {
                //console.log(destination, source);
                if (isEmpty(destination) && source.droppableId === 'expressionDest') {
                    const expr = data.expression[source.index];
                    data.expression.splice(source.index, 1);
                    if (expr.link) {
                        data.expression = data.expression.filter(e => e.key !== expr.link)
                    }

                    setData(data);
                    return;
                }

                if (destination === null) {
                    return;
                }
                if (destination.droppableId !== 'expressionDest' || isEmpty(source)) {
                    return;
                }
                setExprErrorPos();
                if (source.droppableId === 'expressionDest') {
                    const [remove] = data.expression.splice(source.index, 1);
                    data.expression.splice(destination.index, 0, remove);
                } else if (source.droppableId === 'indicatorsSrc') {
                    const expr = { key: nextKey() };
                    expr.name = props.indicators[source.index].name;
                    expr.desc = props.indicators[source.index].desc;
                    data.expression.splice(destination.index, 0, expr);
                } else if (source.droppableId === 'operatorsSrc') {
                    const op = calculatingOperators[source.index];
                    if (op.op === '()') {
                        const lp = { key: nextKey(), op: '(' };
                        const rp = { key: nextKey(), op: ')' };
                        lp.link = rp.key;
                        rp.link = lp.key;
                        data.expression.push(lp);
                        data.expression.push(rp);
                    } else {
                        const expr = { key: nextKey(), op: op.op };
                        data.expression.splice(destination.index, 0, expr);
                    }
                }
                setData(data);
            }}
        >
            <Row style={{ margin: '12px 0 0 0' }}>
                <Col style={{ alignSelf: 'center' }}>
                    <span>表达式：</span>
                </Col>
                <Col style={{ padding: '1px', border: '1px dotted' }}>
                    {expression}
                </Col>
            </Row>
            {/* {data.expression?.length > 0 && <Row style={{ margin: '12px 0 0 0'}}>
                <Col flex='56px'></Col>
                <Col style={{border: '1px dotted red', padding: '2px'}}>
                    <DeleteOutlined style={{color: 'gray'}} />
                    <span style={{color: 'gray'}}>拖动表达式中的节点到此处,可以删除此节点</span>
                </Col>
            </Row>} */}
            <Divider style={{ margin: '10px 0' }} />
            <Row>
                <Col flex='50%'>
                    {operators}
                    {constVal}
                </Col>
                <Col flex='50%'>
                    {indicators}
                </Col>
            </Row>
        </DragDropContext>
    </Modal>
}

function DimensionsOrderModal(props) {
    const [incomingOrderKey, setIncomingOrderKey] = useState();
    const [orderKeys, setOrderKeys] = useState(props.orderKeys);


    const onAddOrderKey = () => {
        if (isEmpty(incomingOrderKey)) {
            message.error('输入的键值不能为空');
            return;
        }
        if (orderKeys.find(key => key === incomingOrderKey)) {
            message.error('输入的键值不能重复');
            return;
        }
        setOrderKeys([...orderKeys, incomingOrderKey]);
        setIncomingOrderKey();
    };

    return <Modal
        {...props}
        onOk={() => props.onOk(orderKeys, props.index)}
        title="自定义排序"
        width={400}
        maskClosable={false}
    >
        <DragDropContext
            onDragEnd={({ destination, source }) => {
                if (isEmpty(destination) || isEmpty(source)) {
                    return;
                }
                const [remove] = orderKeys.splice(source.index, 1);
                orderKeys.splice(destination.index, 0, remove);
                setOrderKeys(orderKeys);
            }}
        >
            <Droppable
                droppableId='orderKeysDest'
            >
                {provided => <>
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        style={{
                            height: 300,
                            overflowX: 'auto'
                        }}
                    > {orderKeys.length === 0 && <Row
                        justify='center'
                        style={{ padding: '2px', border: '1px dotted gray' }}
                    >
                        <Col>
                            <span style={{ color: 'gray' }}>还没有增加排序键值;键值可在此处拖动排序</span>
                        </Col>
                    </Row>}
                        {orderKeys.map((key, index) => <Draggable
                            draggableId={key}
                            key={key}
                            index={index}
                        >
                            {p1 => <Row
                                justify='center'
                                ref={p1.innerRef}
                                {...p1.draggableProps}

                            >
                                <Col flex='40px' style={{ alignSelf: 'center' }}>
                                    <Tag>{index + 1}</Tag>
                                </Col>
                                <Col
                                    {...p1.dragHandleProps}
                                    flex='180px'
                                    style={{
                                        backgroundColor: '#52c41a',
                                        padding: '2px 12px 2px 12px',
                                        borderRadius: '4px',
                                        border: '1px solid rgb(221, 234, 255)',
                                        alignSelf: 'center'
                                    }}
                                >
                                    <Row>
                                        <Col>
                                            <span style={{ color: '#ffffff' }}>{key}</span>
                                        </Col>
                                        <Col flex='auto'></Col>
                                        <Col>
                                            <Button
                                                icon={<DeleteOutlined />}
                                                size='small'
                                                type='link'
                                                style={{ color: '#ffffff' }}
                                                onClick={() => setOrderKeys(orderKeys.filter((_, i) => i !== index))}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>}
                        </Draggable>)}
                    </div>
                    {provided.placeholder}
                </>}
            </Droppable>
        </DragDropContext>
        <Divider style={{ margin: '10px 0' }} />
        <Row>
            <Col>增加值：</Col>
            <Col>
                <Input
                    value={incomingOrderKey}
                    size='small'
                    onChange={({ target: { value } }) => setIncomingOrderKey(value)}
                    onPressEnter={onAddOrderKey}
                />
            </Col>
            <Col>
                <Button
                    size='small'
                    icon={<PlusOutlined />}
                    type='link'
                    onClick={onAddOrderKey}
                />
            </Col>
        </Row>
    </Modal>;
}

export default VisualizationEditingView;